import React from 'react'

import FilterBreadcrumbs from 'components/filterBreadcrumbs/FilterBreadcrumbs'

const EventFilter = ({ filter }) => <FilterBreadcrumbs query={filter} />

export default EventFilter
